export const dateTimeFormat = new Intl.DateTimeFormat("en", {
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
    hour: "numeric",
    minute: "2-digit",
});

export const formatDate = (str: string): string => {
    if (!str) {
        return "";
    }
    try {
        return dateTimeFormat.format(new Date(str)).replace(",", "");
    } catch {
        return "";
    }
};
